"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var use_icon_props_1 = __importDefault(require("../utils/use-icon-props"));
var use_stroke_width_1 = __importDefault(require("../utils/use-stroke-width"));
var Warning = function (props) {
    var iconProps = (0, use_icon_props_1.default)(props);
    var strokeWidth = (0, use_stroke_width_1.default)(iconProps.width);
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("path", { d: "M2.44273 23.9075C1.18273 26.1675 2.76273 28.9975 5.28273 28.9975H26.7227C29.2427 28.9975 30.8227 26.1675 29.5627 23.9075L18.8427 4.6975C17.5827 2.4375 14.4227 2.4375 13.1627 4.6975L2.44273 23.9075Z", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M15.84 25.5C15.33 25.5 14.9 25.32 14.54 24.96C14.18 24.6 14 24.16 14 23.66C14 23.16 14.18 22.72 14.54 22.36C14.9 22 15.34 21.82 15.84 21.82C16.34 21.82 16.78 22 17.14 22.36C17.5 22.72 17.68 23.16 17.68 23.66C17.68 24.16 17.5 24.6 17.14 24.96C16.78 25.32 16.34 25.5 15.84 25.5ZM14.36 19.89L14.15 9H17.52L17.31 19.89H14.36Z", fill: "currentColor" })] })));
};
exports.default = Warning;
//# sourceMappingURL=Warning.js.map